import {PlacementType, FullScreenSheetPlacement} from '@amzn/showtime';

import {getUriRegexString, PreferenceCenterPlacementURI} from '../../utils/uriUtils/uriUtils';
import {emitMetric} from '../../utils/metricsHelper';
import {MetricNames} from '../../common/constant';

const placement: FullScreenSheetPlacement = {
  id: PreferenceCenterPlacementURI.id,
  title: 'Preferences',
  type: PlacementType.FullScreenSheet,
  uri: getUriRegexString(PreferenceCenterPlacementURI),
  rnwPath: getUriRegexString(PreferenceCenterPlacementURI),
  onCloseCompletion: () => {
    emitMetric(MetricNames.UserActionPreferenceCenterScreenClose);
  },
};

export default placement;
